import { Job } from "planning-portal-library/src/lib/core/domain/models/job";
import { Mapper } from "../../../../../core/base";
import { JobMockEntity } from "./job-mock-entity";
import { DateTime, Duration } from "luxon";

export class JobMockRepositoryMapper extends Mapper<JobMockEntity, Job> {
  mapFrom(param: JobMockEntity): Job {
    return {
      id: param.id,
      jobNumber: param.jobNumber,
      vehicleType: param.vehicleType,
      startAddress: param.startAddress,
      endAddress: param.endAddress,
      startTime: param.startTime ? Duration.fromISOTime(param.startTime) : undefined,
      endTime: param.endTime ? Duration.fromISOTime(param.endTime) : undefined,
      startLatitude: param.startLatitude,
      startLongitude: param.startLongitude,
      endLatitude: param.endLatitude,
      endLongitude: param.endLongitude,
      distance: param.distance,
      duration: param.duration ? Duration.fromMillis(param.duration) : undefined,
      planId: param.planId,
      capacityType1: param.capacityType1!,
      capacityType2: param.capacityType2!,
      capacityType3: param.capacityType3,
      qualifications: param.qualifications,
      locationsCount: param.locationsCount!,
      hasUpdate:param.hasUpdate!,
      wayPoints: param.wayPoints || [],
      createdAt: DateTime.fromISO(param.createdAt ?? ""),
      points: param.points,
      additionalData: param.additionalData || {},
    };
  }

  mapTo(param: Job): JobMockEntity {
    return {
      id: param.id,
      jobNumber: param.jobNumber,
      vehicleType: param.vehicleType,
      startAddress: param.startAddress,
      endAddress: param.endAddress,
      startTime: param.startTime?.toISOTime(),
      endTime: param.endTime?.toISOTime(),
      startLatitude: param.startLatitude,
      startLongitude: param.startLongitude,
      endLatitude: param.endLatitude,
      endLongitude: param.endLongitude,
      distance: param.distance,
      duration: param.duration?.toMillis(),
      planId: param.planId,
      capacityType1: param.capacityType1,
      capacityType2: param.capacityType2,
      capacityType3: param.capacityType3,
      qualifications: param.qualifications,
      locationsCount: param.locationsCount,
      hasUpdate:param.hasUpdate!,
      createdAt: param.createdAt.toISO(),
      points: param.points,
      additionalData: param.additionalData,
    };
  }
}
